import React, { useState, useEffect, useRef } from 'react';
import 'datatables.net-buttons-bs5';
import 'datatables.net-responsive-bs5';
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");
import { Card, CardBody } from "reactstrap";
import country from '../../../common/country';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';

function Usage() {
  const selectStates = createSelector(state => state, state => ({
    company: state.MenuData.client,
    usingCampaigns: state.Feed.usingCampaigns
  }));
  const { company, usingCampaigns } = useSelector(selectStates);

  const tableRef = useRef();
  useEffect(() => {
    if (usingCampaigns) {
      const table = $(tableRef.current).DataTable({
        data: usingCampaigns,
        columns: [
          {
            data: null,
            title: `Campaign Name`,
            orderable: false,
            render: (data, type, row) => {
              switch (row.adType) {
                case "display":
                  return `<div class="d-flex gap-3 align-items-center">
                    <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title rounded bg-light text-body fs-3">
                        <svg style='width: 18px; height: 20px; object-fit:contain;' id="Group_5" data-name="Group 5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22.222" height="20" viewBox="0 0 22.222 20">
                          <defs>
                            <clipPath id="clip-path">
                              <rect id="Rectangle_2" data-name="Rectangle 2" width="22.222" height="20" fill="#212529"/>
                            </clipPath>
                          </defs>
                          <g id="Group_4" data-name="Group 4" clip-path="url(#clip-path)">
                            <path id="Path_13" data-name="Path 13" d="M14.444,14.444h4.444V10H17.778v3.333H14.444ZM3.333,7.778H4.444V4.444H7.778V3.333H3.333ZM6.944,20V17.778H1.667a1.6,1.6,0,0,1-1.167-.5A1.6,1.6,0,0,1,0,16.111V1.667A1.6,1.6,0,0,1,.5.5,1.6,1.6,0,0,1,1.667,0H20.556a1.6,1.6,0,0,1,1.167.5,1.6,1.6,0,0,1,.5,1.167V16.111a1.709,1.709,0,0,1-1.667,1.667H15.278V20ZM1.667,16.111H20.556V1.667H1.667Zm0,0v0Z" fill="#212529"/>
                          </g>
                        </svg>
                      </span>
                    </div>
                    <a class="campaign" role="button">${row.name}</a>
                  </div>`;
                case 'social':
                  return `<div class="d-flex gap-3 align-items-center">
                    <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title rounded bg-light text-body fs-3">
                        <i class='ri-facebook-fill'></i>
                      </span>
                    </div>
                    <a class="campaign" role="button">${row.name}</a>
                  </div>`
                case "crm":
                  return `<div class="d-flex gap-3 align-items-center">
                    <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title rounded bg-light text-body fs-3">
                        <i class="ri-mail-line"></i>
                      </span>
                    </div>
                    <a class="campaign" role="button">${row.name}</a>
                  </div>`;
                case "video":
                  return `<div class="d-flex gap-3 align-items-center" >
                    <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title rounded bg-light text-body fs-3">
                        <i class="ri-play-line"></i>
                      </span>
                    </div>
                    <a class="campaign" role="button">${row.name}</a>
                  </div> `;
                default:
                  return `<div class="d-flex gap-3 align-items-center" >
                  <div class="avatar-sm flex-shrink-0">
                    <span class="avatar-title rounded bg-light text-body fs-3">
                    </span>
                  </div>
                  <a class="campaign" role="button">${row.name}</a>
                </div> `
              }
            }
          },
          {
            data: null,
            title: "Market",
            render: (data, type, row) => {
              if (row.hasOwnProperty('marketIcon')) {
                let marketIcon = country.find(item => item.short === row.marketIcon);
                if (marketIcon) {
                  return `<img src="${marketIcon.flagImg}" class="rounded-circle" height="20" draggable="false"  />`
                } else {
                  return ' ';
                }
              } else {
                const foundClient = company.clients.find(item => item._id === row.clientId);
                const foundBrand = foundClient.brands.find(item => item._id === row.brandId);
                const foundMarket = foundBrand.markets.find(item => item._id === row.marketId);
                let marketIcon = country.find(item => item.name === foundMarket.name);
                if (marketIcon) {
                  return `<img src="${marketIcon.flagImg}" class="rounded-circle" height="20" draggable="false"  />`
                } else {
                  return " "
                }
              }
            }
          },
          {
            data: "adType",
            title: "Type",
          },
          {
            data: null,
            title: "Action",
            render: () => {
              return `<button class="btn btn-sm btn-info" > <i class="ri-share-line align-bottom"></i>Showcase</button >`;
            }
          }
        ],
        responsive: true,
        columnDefs: [
          { responsivePriority: 1, targets: [1, -2] },
          { responsivePriority: 2, targets: "_all" }
        ],
        destroy: true,
        searching: false,
        paging: false,
        info: false
      });
      /* eslint-enable no-unused-vars */

      return function () {
        table.destroy();
      }
    }
  }, [usingCampaigns]);
  return (
    <div className='table-responsive table-card'>
      <table className='align-middle table-nowrap mb-0 table' style={{ width: "100%" }} ref={tableRef}>
        <thead className='table-light'></thead>
        <tbody></tbody>
      </table>
    </div>
  )
}

export default Usage
